module.exports = __webpack_public_path__ + "img/買うときの3ステップ.d29f124b.png";